import { App } from 'vue'
import Notifications from '@kyvg/vue3-notification'

export default {
  install(app: App<Element>): any {
    app.use(Notifications)
  }
}
